"use client";
import React from "react";
import { NewScriptForm } from "../../../global";

export default function AmmendNewScript() {
  return (
    <NewScriptForm
      title="Amend Script"
      disablePatient={true}
      disablePractitioner={true}
    />
  );
}
